import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { ApiUrlHelper } from '../api-url-helper/api-url-helper';
import { StateConfigrationModel } from '../../model/StateConfigrationModel';

@Injectable({
    providedIn: 'root'
})
export class StateConfigrationService {
    private stateConfigSubject = new BehaviorSubject<StateConfigrationModel[]>([]);
    public stateConfig$ = this.stateConfigSubject.asObservable();

    private _stateConfigModel: StateConfigrationModel | null = null;

    constructor(private apiService: ApiService, private urls: ApiUrlHelper) { }

    fetchStateConfiguration(): void {
        let apiUrl = this.urls.apiUrl.common.getStateConfigrationList;
        this.apiService.doGet(apiUrl).subscribe({
            next: (response) => {
                if (response.Success) {
                    this.stateConfigSubject.next(response.Data);
                    if (response.Data && response.Data.length > 0) {
                        this.stateConfigModel = response.Data[0]; // Calls the setter automatically
                    }
                }
            },
            error: (err) => {
                console.error('Error fetching state configuration', err);
            }
        });
    }

    // Set method
    set stateConfigModel(value: StateConfigrationModel | null) {
        this._stateConfigModel = value;
    }

    // Get method
    get stateConfigModel(): StateConfigrationModel | null {
        return this._stateConfigModel;
    }

    // Property accessors derived from the assigned model
    get isEnabledForAgent(): boolean {
        return this._stateConfigModel ? this._stateConfigModel.IsEnabledForAgent : false; // Default until fetched
    }

    get isEnabledForCustomer(): boolean {
        return this._stateConfigModel ? this._stateConfigModel.IsEnabledForCustomer : false; // Default until fetched
    }

    get state(): string {
        return this._stateConfigModel ? this._stateConfigModel.State : '';
    }
}
